import { useState } from 'react';
import '../../styles/Home.css';
import Wip from '../../wip';
import STEAMnav from '../../nav/STEAM-Nav';

const STEAM2026 = () => {

  return (




    <div className="container">
      <STEAMnav ></STEAMnav>
      <div>
        <h3 className="center-align"><b>STEAM Olympics 2026 - Bloomington</b></h3>
      </div>

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/FBT.png" alt="" width="70%" className="rounded" /></p>
        </div>

        <div className="col-sm">

          <p className="center-align"><img src="/images/steam/IWU.png" alt="" width="70%" className="rounded" /></p>
        </div>

      </div>

      <div>
        <h5 className="justify c737373"><a href="/"><b>For A Better Tomorrow (FBT)</b></a> and <a href="https://www.iwu.edu/"><b>Illinois Wesleyan University (IWU)</b></a> <b>Proudly Present the 2<sup>nd</sup> Annual STEAM Olympics!. </b></h5>
      </div>

      <div>
        <h5 className="justify c737373">The STEAM Olympics provides a unique opportunity for students of all ages to engage in hands-on experiences, learning, and friendly competition across a variety of STEAM disciplines. Through this event, young thinkers and problem-solvers can delve into subjects that foster creativity, curiosity, and innovation.</h5>
      </div>

      <p >&nbsp;</p>
      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >Event Purpose & Impact</b></h4>
          <h5 className="justify c737373"><i >STEAM Olympics is more than a competition it's a collaborative effort between FBT and IWU to inspire the next generation while supporting impactful initiatives. Proceeds from this event will help fund scholarships and support grants for projects on both local and global scales. In particular, FBT will award financial need-based scholarships to IWU students involved in the Council of Inclusion and Awareness (CIA), promoting social justice and community engagement.</i></h5>
        </div>

      </div>

      <p >&nbsp;</p>
      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >Math and Science Debriefs</b></h4>
        </div>

      </div>

      <div className="row">

        <div className="col-sm">
          <h4 className="center-align"><a className="btn btn-primary btn-lg " href="https://youtu.be/gAKx7s_oHME" role="button">Math Level 1</a></h4>
        </div>

        <div className="col-sm">
          <h4 className="center-align"><a className="btn btn-primary btn-lg " href="https://youtu.be/M-RCEL6sT-U" role="button">Math Level 2</a></h4>
        </div>

        <div className="col-sm">
          <h4 className="center-align"><a className="btn btn-primary btn-lg " href="https://youtu.be/P5h82cMRdoA" role="button">Math Level 3</a></h4>
        </div>

      </div>

      <div className="row">

        <div className="col-sm">
          <h4 className="center-align"><a className="btn btn-primary btn-lg " href="https://youtu.be/fYCpjrY9YRM" role="button">Science Level 1</a></h4>
        </div>

        <div className="col-sm">
          <h4 className="center-align"><a className="btn btn-primary btn-lg " href="https://youtu.be/vCCkv2ioXzE" role="button">Science Level 2</a></h4>
        </div>

        <div className="col-sm">
          <h4 className="center-align"><a className="btn btn-primary btn-lg " href="https://youtu.be/Gc1CqCsQMvY" role="button">Science Level 3</a></h4>
        </div>

      </div>

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h4 className="center-align"><b >Event Winners</b></h4>
        </div>

      </div>

      <div ROW>

        <div className="col-sm">

          <h5 className="center-align"><b className="cRed">Math Test</b></h5>
        </div>

      </div>

      <div className="row">

        <table className="table table-bordered">

          <thead>

            <tr>
              <th scope="col" className="center-align">Level</th>
              <th scope="col" className="center-align">Grade</th>
              <th scope="col" className="center-align">Gold</th>
              <th scope="col" className="center-align">Silver</th>
              <th scope="col" className="center-align">Bronze</th>
            </tr>

          </thead>

          <tbody>

            <tr>
              <td rowspan="3" className="center-align align-middle">Level 1</td>
              <td className="center-align align-middle">Grade 1</td>
              <td className="center-align">Agastya Pawar<br /> <span className="c737373">(Metcalf)</span></td>
              <td className="center-align">Aarav Saththivel<br /> <span className="c737373">(Hickory Grove)</span></td>
              <td className="center-align">Mithra Sivalingam<br /> <span className="c737373">(Grove)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 2</td>
              <td className="center-align">Edrick Ding<br /> <span className="c737373">(Metcalf)</span></td>
              <td className="center-align">Vishaan Santhoshrajan<br /> <span className="c737373">(Grove)</span></td>
              <td className="center-align">Sharvika Dinesh Sonawane<br /> <span className="c737373">(Colene Hoose)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 3</td>
              <td className="center-align">Ranvit Pitti<br /> <span className="c737373">(Grove)</span></td>
              <td className="center-align">Matthew Hu<br /> <span className="c737373">(Robeson Elementary)</span></td>
              <td className="center-align">Ronik Manna<br /> <span className="c737373">(Metcalf)</span></td>
            </tr>

            <tr>
              <td rowspan="2" className="center-align align-middle">Level 2</td>
              <td className="center-align align-middle">Grade 4</td>
              <td className="center-align">Tanish Sen<br /> <span className="c737373">(Grove)</span></td>
              <td className="center-align">Daksh Sudera<br /> <span className="c737373">(Grove)</span></td>
              <td className="center-align">Aiden Tan<br /> <span className="c737373">(Barkstall)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 5</td>
              <td className="center-align">Aniket Singh<br /> <span className="c737373">(Benjamin)</span></td>
              <td className="center-align">Pahal Sheth<br /> <span className="c737373">(Benjamin)</span></td>
              <td className="center-align">Rithvik Charan Saravanan<br /> <span className="c737373">(Benjamin)</span></td>
            </tr>

            <tr>
              <td rowspan="3" className="center-align align-middle">Level 3</td>
              <td className="center-align align-middle">Grade 6</td>
              <td className="center-align">Anirudh Dhawan<br /> <span className="c737373">(Evans)</span></td>
              <td className="center-align">Sudeep Panyaram<br /> <span className="c737373">(Evans)</span></td>
              <td className="center-align">Abhinav Chander<br /> <span className="c737373">(Evans)</span><br />Jai Jadon<br /> <span className="c737373">(Evans)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 7</td>
              <td className="center-align">Harshit Giri<br /> <span className="c737373">(Chiddix)</span></td>
              <td className="center-align">Lohith Reddy Gongati<br /> <span className="c737373">(Chiddix)</span></td>
              <td className="center-align">Tej Shah<br /> <span className="c737373">(Evans)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 8</td>
              <td className="center-align">Aanya Mahajan<br /> <span className="c737373">(Evans)</span></td>
              <td className="center-align">Nagpavan Parasa<br /> <span className="c737373">(Evans)</span></td>
              <td className="center-align">Nathan Shaun Kota<br /> <span className="c737373">(Evans)</span></td>
            </tr>

          </tbody>

        </table>

      </div>

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h5 className="center-align"><b className="cRed">Science Test</b></h5>
        </div>

      </div>

      <div className="row">

        <table className="table table-bordered">

          <thead>

            <tr>
              <th scope="col" className="center-align">Level</th>
              <th scope="col" className="center-align">Grade</th>
              <th scope="col" className="center-align">Gold</th>
              <th scope="col" className="center-align">Silver</th>
              <th scope="col" className="center-align">Bronze</th>
            </tr>

          </thead>

          <tbody>

            <tr>
              <td rowspan="3" className="center-align align-middle">Level 1</td>
              <td className="center-align align-middle">Grade 1</td>
              <td className="center-align">Mithra Sivalingam<br /> <span className="c737373">(Grove)</span></td>
              <td className="center-align">Miraa Divaagar<br /> <span className="c737373">(Northpoint)</span></td>
              <td className="center-align">Oscar Owen<br /> <span className="c737373">(Washington Elementary)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 2</td>
              <td className="center-align">Harrison Henline<br /> <span className="c737373">(Pepper Ridge Elementary)</span></td>
              <td className="center-align">Esha Arvind<br /> <span className="c737373">(Grove School)</span></td>
              <td className="center-align">Sharvika Dinesh Sonawane<br /> <span className="c737373">(Colene Hoose)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 3</td>
              <td className="center-align">Arav Karthik<br /> <span className="c737373">(Thomas Metcalf)</span></td>
              <td className="center-align">Arya Parmar<br /> <span className="c737373">(Glenn Elementary)</span></td>
              <td className="center-align">Arjun Mittal<br /> <span className="c737373">(Benjamin)</span></td>
            </tr>

            <tr>
              <td rowspan="2" className="center-align align-middle">Level 2</td>
              <td className="center-align align-middle">Grade 4</td>
              <td className="center-align">Shree Aytam<br /> <span className="c737373">(Northpoint)</span></td>
              <td className="center-align">Daksh Sudera<br /> <span className="c737373">(Grove)</span></td>
              <td className="center-align">Tanish Sen<br /> <span className="c737373">(Grove)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 5</td>
              <td className="center-align">Aadhav Kumar<br /> <span className="c737373">(Benjamin)</span></td>
              <td className="center-align">Pahal Sheth<br /> <span className="c737373">(Benjamin)</span></td>
              <td className="center-align">Rai Manna<br /> <span className="c737373">(Metcalf)</span></td>
            </tr>

            <tr>
              <td rowspan="3" className="center-align align-middle">Level 3</td>
              <td className="center-align align-middle">Grade 6</td>
              <td className="center-align">Prewitt Rout<br /> <span className="c737373">(Kingsley)</span></td>
              <td className="center-align">Abhinav Chander<br /> <span className="c737373">(Evans)</span></td>
              <td className="center-align">Jai Jadon<br /> <span className="c737373">(Evans)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 7</td>
              <td className="center-align">Joe Gaudin<br /> <span className="c737373">(Kingsley)</span></td>
              <td className="center-align">Harshit Giri<br /> <span className="c737373">(Chiddix)</span></td>
              <td className="center-align">Darsh Yadav<br /> <span className="c737373">(Evans)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 8</td>
              <td className="center-align">Aanya Mahajan<br /> <span className="c737373">(Evans)</span></td>
              <td className="center-align">Nagpavan Parasa<br /> <span className="c737373">(Evans)</span></td>
              <td className="center-align">Nathan Shaun Kota<br /> <span className="c737373">(Evans)</span></td>
            </tr>

          </tbody>

        </table>

      </div>

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h5 className="center-align"><b className="cRed">Spelling Bee</b></h5>
        </div>

      </div>

      <div className="row">

        <table className="table table-bordered">

          <thead>

            <tr>
              <th scope="col" className="center-align">Level</th>
              <th scope="col" className="center-align">Grade</th>
              <th scope="col" className="center-align">Gold</th>
              <th scope="col" className="center-align">Silver</th>
              <th scope="col" className="center-align">Bronze</th>
            </tr>

          </thead>

          <tbody>

            <tr>
              <td rowspan="3" className="center-align align-middle">Level 1</td>
              <td className="center-align align-middle">Grade 1</td>
              <td className="center-align">Advay Anand<br /> <span className="c737373">(Northpoint)</span></td>
              <td className="center-align"></td>
              <td className="center-align"></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 2</td>
              <td className="center-align">Viyan Senthil<br /> <span className="c737373">(Northpoint)</span></td>
              <td className="center-align">Vishaan Santhoshrajan<br /> <span className="c737373">(Grove School)</span><br />Myra Mehrotra<br /> <span className="c737373">(Northpoint)</span></td>
              <td className="center-align">Harrison Henline<br /> <span className="c737373">(Pepper Ridge)</span><br />Kavan Chandran<br /> <span className="c737373">(Towanda Elementary)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 3</td>
              <td className="center-align">Aadhya Arun<br /> <span className="c737373">(Prairieland elementary)</span></td>
              <td className="center-align">Arjun Mittal<br /> <span className="c737373">(Benjamin)</span><br />Aishani Singh<br /> <span className="c737373">(Benjamin)</span></td>
              <td className="center-align">Charvi Konkati<br /> <span className="c737373">(Oakland Elementary School)</span><br />Ranvit Pitti<br /> <span className="c737373">(Grove)</span><br />Advesh Chingalwar<br /> <span className="c737373">(Northpoint)</span></td>
            </tr>

            <tr>
              <td rowspan="2" className="center-align align-middle">Level 2</td>
              <td className="center-align align-middle">Grade 4</td>
              <td className="center-align">Daksh Sudera<br /> <span className="c737373">(Grove)</span><br />Shreeya Ponna<br /> <span className="c737373">(Grove)</span></td>
              <td className="center-align">Tanish Sen<br /> <span className="c737373">(Grove)</span><br />Daania Zaffari<br /> <span className="c737373">(Benjamin)</span></td>
              <td className="center-align">Aadya Pandranki<br /> <span className="c737373">(Grove)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 5</td>
              <td className="center-align">Abbie Eckhardt<br /> <span className="c737373">(Reservoir Gifted Academy)</span></td>
              <td className="center-align">Aaditha Simon<br /> <span className="c737373">(Prairieland Elementary)</span></td>
              <td className="center-align">Emma Hughes<br /> <span className="c737373">(Towanda Elementary)</span></td>
            </tr>

            <tr>
              <td rowspan="3" className="center-align align-middle">Level 3</td>
              <td className="center-align align-middle">Grade 6</td>
              <td className="center-align">Abhinav Chander<br /> <span className="c737373">(Evans Junior High)</span></td>
              <td className="center-align">Anirudh Dhawan<br /> <span className="c737373">(Evans)</span></td>
              <td className="center-align">Serah Rose Arun<br /> <span className="c737373">(Epiphan catholic school)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 7</td>
              <td className="center-align">Harshit Giri<br /> <span className="c737373">(Chiddix)</span></td>
              <td className="center-align">Rylan Nayak<br /> <span className="c737373">(Evans)</span></td>
              <td className="center-align"></td>
            </tr>

            <tr>
              <td className="center-align">Grade 8</td>
              <td className="center-align">Nagpavan Parasa<br /> <span className="c737373">(Evans)</span></td>
              <td className="center-align">August Reblando<br /> <span className="c737373">(Kingsley)</span></td>
              <td className="center-align">Sejal Maheshwari<br /> <span className="c737373">(EJHS)</span></td>
            </tr>

          </tbody>

        </table>

      </div>

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h5 className="center-align"><b className="cRed">Essay Writing</b></h5>
        </div>

      </div>

      <div className="row">

        <table className="table table-bordered">

          <thead>

            <tr>
              <th scope="col" className="center-align">Level</th>
              <th scope="col" className="center-align">Grade</th>
              <th scope="col" className="center-align">Gold</th>
              <th scope="col" className="center-align">Silver</th>
              <th scope="col" className="center-align">Bronze</th>
            </tr>

          </thead>

          <tbody>

            <tr>
              <td rowspan="3" className="center-align align-middle">Level 1</td>
              <td className="center-align align-middle">Grade 1</td>
              <td className="center-align">Aarav Ranjan<br /> <span className="c737373">(Benjamin)</span></td>
              <td className="center-align">Mithra Sivalingam<br /> <span className="c737373">(Grove)</span></td>
              <td className="center-align"></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 2</td>
              <td className="center-align">Viyan Senthil<br /> <span className="c737373">(Northpoint)</span></td>
              <td className="center-align">Nehasritha Pradheep<br /> <span className="c737373">(Benjamin)</span></td>
              <td className="center-align">Sharvika Dinesh Sonawane<br /> <span className="c737373">(Colene Hoose)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 3</td>
              <td className="center-align">Arjun Mittal<br /> <span className="c737373">(Benjamin)</span></td>
              <td className="center-align">Aishani Singh<br /> <span className="c737373">(Benjamin)</span></td>
              <td className="center-align">Arya Parmar<br /> <span className="c737373">(Glenn)</span></td>
            </tr>

            <tr>
              <td rowspan="2" className="center-align align-middle">Level 2</td>
              <td className="center-align align-middle">Grade 4</td>
              <td className="center-align">Shreeya Ponna<br /> <span className="c737373">(Grove)</span></td>
              <td className="center-align">Jiya Mehta<br /> <span className="c737373">(Benjamin)</span></td>
              <td className="center-align">Shree Aytam<br /> <span className="c737373">(Northpoint)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 5</td>
              <td className="center-align">Kiaan Chhabra<br /> <span className="c737373">(Grove)</span></td>
              <td className="center-align">Aaditha Simon<br /> <span className="c737373">(Prairieland)</span><br />Pahal Sheth<br /> <span className="c737373">(Benjamin)</span></td>
              <td className="center-align">Akshaya Senthilkumar<br /> <span className="c737373">(Benjamin)</span></td>
            </tr>

            <tr>
              <td rowspan="3" className="center-align align-middle">Level 3</td>
              <td className="center-align align-middle">Grade 6</td>
              <td className="center-align">Abhinav Chander<br /> <span className="c737373">(Evans)</span></td>
              <td className="center-align">Anirudh Dhawan<br /> <span className="c737373">(Evans)</span></td>
              <td className="center-align">Ananshi Sewak<br /> <span className="c737373">(Evans)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 7</td>
              <td className="center-align">Darsh Yadav<br /> <span className="c737373">(Evans)</span></td>
              <td className="center-align">Anusha Singh<br /> <span className="c737373">(EJHS)</span></td>
              <td className="center-align">Chandra Padigala<br /> <span className="c737373">(Evans)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 8</td>
              <td className="center-align">Aanya Mahajan<br /> <span className="c737373">(Evans)</span></td>
              <td className="center-align">Sumedha Yarlagadda<br /> <span className="c737373">(Evans)</span></td>
              <td className="center-align">Sejal Maheshwari<br /> <span className="c737373">(EJHS)</span></td>
            </tr>

          </tbody>

        </table>

      </div>

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h5 className="center-align"><b className="cRed">Speech</b></h5>
        </div>

      </div>

      <div className="row">

        <table className="table table-bordered">

          <thead>

            <tr>
              <th scope="col" className="center-align">Level</th>
              <th scope="col" className="center-align">Grade</th>
              <th scope="col" className="center-align">Gold</th>
              <th scope="col" className="center-align">Silver</th>
              <th scope="col" className="center-align">Bronze</th>
            </tr>

          </thead>

          <tbody>

            <tr>
              <td rowspan="3" className="center-align align-middle">Level 1</td>
              <td className="center-align align-middle">Grade 1</td>
              <td className="center-align">Aarav Ranjan<br /> <span className="c737373">(Benjamin)</span></td>
              <td className="center-align"></td>
              <td className="center-align"></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 2</td>
              <td className="center-align">Myra Mehrotra<br /> <span className="c737373">(Northpoint)</span></td>
              <td className="center-align">Safiyyah Zaffari<br /> <span className="c737373">(Benjamin)</span><br />Sharvika Dinesh Sonawane<br /> <span className="c737373">(Colene Hoose)</span></td>
              <td className="center-align">Esha Arvind<br /> <span className="c737373">(Grove School)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 3</td>
              <td className="center-align">Abhijay Abburi<br /> <span className="c737373">(Benjamin)</span></td>
              <td className="center-align">Arya Parmar<br /> <span className="c737373">(Glenn Elementary)</span></td>
              <td className="center-align">Arav Karthik<br /> <span className="c737373">(Thomas Metcalf)</span></td>
            </tr>

            <tr>
              <td rowspan="2" className="center-align align-middle">Level 2</td>
              <td className="center-align align-middle">Grade 4</td>
              <td className="center-align">Shree Aytam<br /> <span className="c737373">(Northpoint)</span></td>
              <td className="center-align">Daania Zaffari<br /> <span className="c737373">(Benjamin)</span></td>
              <td className="center-align">Abhiram Kulkarni<br /> <span className="c737373">(Benjamin)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 5</td>
              <td className="center-align">Pahal Sheth<br /> <span className="c737373">(BENJAMIN)</span></td>
              <td className="center-align">Hunter Lyons<br /> <span className="c737373">(Tri Valley Middle)</span></td>
              <td className="center-align">Kanishkaa Sri Vengala<br /> <span className="c737373">(Benjamin)</span></td>
            </tr>

            <tr>
              <td rowspan="3" className="center-align align-middle">Level 3</td>
              <td className="center-align align-middle">Grade 6</td>
              <td className="center-align">Akshay Ayyapusetty<br /> <span className="c737373">(Clifford Crone Middle school)</span></td>
              <td className="center-align">Mishika Rout<br /> <span className="c737373">(Chiddix jr high)</span></td>
              <td className="center-align">Abhinav Chander<br /> <span className="c737373">(Evans Junior High)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 7</td>
              <td className="center-align">Anusha Singh<br /> <span className="c737373">(EJHS)</span></td>
              <td className="center-align">Anusha Ranjan<br /> <span className="c737373">(Evans jr high school)</span></td>
              <td className="center-align">Lohith Reddy Gongati<br /> <span className="c737373">(Chiddix Junior high)</span></td>
            </tr>

            <tr>
              <td className="center-align align-middle">Grade 8</td>
              <td className="center-align">Sejal Maheshwari<br /> <span className="c737373">(EJHS)</span></td>
              <td className="center-align">Rayansh Pitti<br /> <span className="c737373">(Chiddix Junior High)</span></td>
              <td className="center-align">Aanya Mahajan<br /> <span className="c737373">(Evan s junior high)</span></td>
            </tr>

          </tbody>

        </table>

      </div>

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h5 className="center-align"><b className="cRed">Debate</b></h5>
        </div>

      </div>

      <div className="row">

        <table className="table table-bordered">

          <thead>

            <tr>
              <th scope="col" className="center-align">Gold</th>
            </tr>

          </thead>

          <tbody>

            <tr>
              <td className="center-align">Sidak Bindra<br /> <span className="c737373">(NCHS)</span><br />
                Rishabhakrishna Narendranath<br /> <span className="c737373">(NCHS)</span><br />
                Shloka Chebolu<br /> <span className="c737373">()</span></td>
            </tr>

          </tbody>

        </table>

      </div>

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h5 className="center-align"><b className="cRed">STEAM Quest</b></h5>
        </div>

      </div>

      <div className="row">

        <table className="table table-bordered">

          <thead>

            <tr>
              <th scope="col" className="center-align">Level</th>
              <th scope="col" className="center-align">Gold</th>
              <th scope="col" className="center-align">Silver</th>
              <th scope="col" className="center-align">Bronze</th>
            </tr>

          </thead>

          <tbody>

            <tr>
              <td rowspan="1" className="center-align align-middle">Level 1</td>
              <td className="center-align">Matthew Hu<br /> <span className="c737373">(Robeson Elementary)</span><br />
                Arav Karthik<br /> <span className="c737373">(Metcalf)</span>
              </td>
              <td className="center-align">Oscar Owen<br /> <span className="c737373">(Washington Elementary)</span><br />
                Roman Eckhardt<br /> <span className="c737373">(Northpoint)</span><br />
                Ranvit Pitti<br /> <span className="c737373">(Northpoint)</span><br />
                Owen Eckhardt<br /> <span className="c737373">(Aletheia Christian School)</span></td>
              <td className="center-align">Agastya Pawar<br /> <span className="c737373">(Metcalf)</span><br />
                Virjaa<br /> <span className="c737373">(Metcalf)</span><br />
                Abhijay Abburi<br /> <span className="c737373">(Benjamin)</span></td>
            </tr>

            <tr>
              <td rowspan="1" className="center-align align-middle">Level 2</td>
              <td className="center-align">Tanish Sen<br /> <span className="c737373">(Grove School)</span><br />
                Aiden Tan<br /> <span className="c737373">(Barkstall Elementary)</span><br />
                Hunter Lyons<br /> <span className="c737373">(Tri Valley Middle)</span><br />
                Aaditha Simon<br /> <span className="c737373">(Prairieland Elementary)</span></td>
              <td className="center-align">Daania Zaffari<br /> <span className="c737373">(Benjamin)</span><br />
                Saesha Dhorajia<br /> <span className="c737373">(Benjamin)</span><br />
                Misri Shah<br /> <span className="c737373">(Benjamin)</span><br />
                Ria Contractor<br /> <span className="c737373">(Benjamin)</span></td>
              <td className="center-align">Pahal Sheth<br /> <span className="c737373">(BENJAMIN)</span><br />
                Kanishkaa Sri Vengala<br /> <span className="c737373">(Benjamin)</span><br />
                Raya Maryam Hameed<br /> <span className="c737373">(Benjamin)</span><br />
                Maargi Kulkarni<br /> <span className="c737373">(Benjamin)</span></td>
            </tr>

            <tr>
              <td rowspan="1" className="center-align align-middle">Level 3</td>
              <td className="center-align">Anirudh Dhawan<br /> <span className="c737373">(EJHS)</span><br />
                Sudeep Panyaram<br /> <span className="c737373">(Evans)</span><br />
                Abhinav Chander<br /> <span className="c737373">(Evans)</span><br />
                Akshay Ayyapusetty<br /> <span className="c737373">(Clifford Crone Middle School)</span></td>
              <td className="center-align">Tej Shah<br /> <span className="c737373">(Evans)</span><br />
                Darsh Yadav<br /> <span className="c737373">(Evans)</span><br />
                Neal Sheth<br /> <span className="c737373">(Evans)</span><br />
                Ridhaan Shinde<br /> <span className="c737373">(Evans)</span></td>
              <td className="center-align">Rylan Nayak<br /> <span className="c737373">(Evans)</span><br />
                Ryan Nayak<br /> <span className="c737373">(Evans)</span><br />
                Sanchit Gupta<br /> <span className="c737373">(Evans)</span><br />
                Aarav Choudhry<br /> <span className="c737373">(Evans)</span></td>
            </tr>

            <tr>
              <td rowspan="1" className="center-align align-middle">Level 4</td>
              <td className="center-align">Sreenivas Saravanakumar<br /> <span className="c737373">(NCHS)</span></td>
              <td className="center-align">Alexandru Ciofoaia<br /> <span className="c737373">(Dunlap high school)</span></td>
              <td className="center-align"></td>
            </tr>

          </tbody>

        </table>

      </div>

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h5 className="center-align"><b className="cRed">Science Fair</b></h5>
        </div>

      </div>

      <div className="row">

        <table className="table table-bordered">

          <thead>

            <tr>
              <th scope="col" className="center-align">Level</th>
              <th scope="col" className="center-align">Best Visual / Best Original Design</th>
              <th scope="col" className="center-align">Best Execution & Ownership</th>
              <th scope="col" className="center-align">Most Collaborative</th>
            </tr>

          </thead>

          <tbody>

            <tr>
              <td rowspan="1" className="center-align align-middle">Level 1</td>
              <td className="center-align">Sharvika Dinesh Sonawane<br /> <span className="c737373">(Colene Hoose)</span><br />
                Arya Parmar<br /> <span className="c737373">(Colene Hoose)</span><br />
                Aishani Singh<br /> <span className="c737373">(Colene Hoose)</span><br />
                Myra Mehrotra<br /> <span className="c737373">(Colene Hoose)</span></td>
              <td className="center-align">Ranvit Pitti<br /> <span className="c737373">(Gorve)</span><br />
                Devansh Bandaru<br /> <span className="c737373">(Gorve)</span><br />
                Ayansh Raut<br /> <span className="c737373">(Gorve)</span></td>
              <td className="center-align">Aarav Ranjan<br /> <span className="c737373">(benjamin)</span><br />
                Janhvi Deivendran<br /> <span className="c737373">(benjamin)</span><br />
                Hanshri Ayyalusamy<br /> <span className="c737373">(benjamin)</span><br />
                Kavinandhan Saravanan<br /> <span className="c737373">(benjamin)</span></td>
            </tr>

            <tr>
              <td rowspan="1" className="center-align align-middle">Level 2</td>
              <td className="center-align">Tanish Sen<br /> <span className="c737373">(Gorve)</span><br />
                Daksh Sudera<br /> <span className="c737373">(Gorve)</span><br />
                Ryan Samuel<br /> <span className="c737373">(Gorve)</span><br />
                Ahaan Vijayvargiya<br /> <span className="c737373">(Gorve)</span></td>
              <td className="center-align">Pahal Sheth<br /> <span className="c737373">(Benjamin)</span><br />
                Kanishkaa Vengala<br /> <span className="c737373">(Benjamin)</span><br />
                Raya<br /> <span className="c737373">(Benjamin)</span><br />
                Maargi Kulkani<br /> <span className="c737373">(Benjamin)</span></td>
              <td className="center-align">Tanush Marlapaty<br /> <span className="c737373">(Benjamin)</span><br />
                Arnav Chauk<br /> <span className="c737373">(Benjamin)</span><br />
                Sivansh Parasa<br /> <span className="c737373">(Benjamin)</span><br />
                Achinth Anand<br /> <span className="c737373">(Benjamin)</span></td>
            </tr>

            <tr>
              <td rowspan="1" className="center-align align-middle">Level 3</td>
              <td className="center-align">Tej Shah<br /> <span className="c737373">(Evans)</span><br />
                Neal Sheth<br /> <span className="c737373">(Evans)</span><br />
                Darsh Yadav<br /> <span className="c737373">(Evans)</span><br />
                Ridhaan Shinde<br /> <span className="c737373">(Evans)</span></td>
              <td className="center-align">Haasini Konakanchi<br /> <span className="c737373">(Evans)</span><br />
                Srinidhi Goli<br /> <span className="c737373">(Evans)</span><br />
                Harini Gudla<br /> <span className="c737373">(Evans)</span><br />
                Shruthika Geejula<br /> <span className="c737373">(Evans)</span></td>
              <td className="center-align">Rayansh Pitti<br /> <span className="c737373">(Chiddix)</span><br />
                Nagpavan Parasa<br /> <span className="c737373">(Chiddix)</span><br />
                Himanshu Saggu<br /> <span className="c737373">(Chiddix)</span><br />
                Darshan Ayyanar<br /> <span className="c737373">(Chiddix)</span></td>
            </tr>

          </tbody>

        </table>

      </div>

      <div><hr class="hr-line"></hr></div>

      <div className="row">

        <div className="col-sm">

          <h5 className="center-align"><b className="cRed">STEAM 2026 Champions</b></h5>
        </div>

      </div>

      <div className="row">

        <table className="table table-bordered">

          <thead>

            <tr>
              <th scope="col" className="center-align">George Evans Junior High School</th>
            </tr>

          </thead>

        </table>

      </div>

      <div><hr class="hr-line"></hr></div>

    </div>





  );
}
export default STEAM2026;
